import useEventCityGet from "../../eventCities/hooks/useEventCityGet";
import Prebooking from "../../booking/types/Prebooking";
import {extractIdFromPath} from "../../transfers/utils/extractIdFromPath";
import EventCity from "../../eventCities/types/EventCity";
import useCityGet from "../../cities/hooks/useCityGet";
import City from "../../cities/types/City";
import useHotelDetailsGet from "../../hotels/hooks/useHotelDetailsGet";
import HotelDetail from "../../hotels/types/HotelDetail";
import useGetPrebookingMe from "../../booking/hooks/useGetPrebookingMe";

interface UsePackageDataOutput {
    preBooking?: Prebooking;
    eventCity?: EventCity;
    city?: City;
    hotelInfo?: HotelDetail;
    isLoading: boolean;
}

export default function usePackageData(
  preBookingInternalId: string | undefined
): UsePackageDataOutput {
    const prebookingQuery = useGetPrebookingMe(preBookingInternalId);
    const {data: preBooking, isLoading: isPreBookingLoading} = prebookingQuery;

    const cityEventId = extractIdFromPath(preBooking?.cityEvent);
    const eventCityQuery = useEventCityGet(cityEventId ?? 0, {execute: !!cityEventId && !!preBooking});
    const {data: eventCity, isLoading: isEventCityLoading} = eventCityQuery;

    const cityInfoQuery = useCityGet(eventCity?.city ?? 'cities/0', {execute: !!eventCity?.city});
    const {data: city, isLoading: isCityLoading} = cityInfoQuery;

    const hotelInfoQuery = useHotelDetailsGet(`/hotel_events/${extractIdFromPath(preBooking?.prebookingHotel?.hotelEvent)}`,
      {execute: !!preBooking?.prebookingHotel?.hotelEvent}
    );
    const {data: hotelInfo, isLoading: isHotelInfoLoading} = hotelInfoQuery;

    const isLoading = isEventCityLoading || isPreBookingLoading || isCityLoading || isHotelInfoLoading;

    return {preBooking, eventCity, city, hotelInfo, isLoading};
}
